import {doc, getDoc, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { getCollection } from "./data"

export class Weed
{
	constructor(name)
	{
		this.name = name;
		this.id = name;
	}

	async submitAsNew()
	{
		const {id, ...rest} = this;
		var projectRef = doc(db, "Weeds", id);
		let snapshot = await getDoc(projectRef);
		if (!snapshot.exists()) {
			let resp = await setDoc(doc(db, "Weeds", id), { ...rest });
			return resp;
		}
	}

	static async submitUpdate(p)
	{
		const {id, ...rest} = p;
		let resp = await setDoc(doc(db, "Weeds", id), { ...rest });
		return resp;
	}

	static async getAll()
	{
		return await getCollection("Weeds");
	}

	static async deleteAndUpdate(selection,weeds,setWeeds)
	{
		weeds = weeds.filter( project=>{
			const key = project.id;
			if(selection.includes(key))
			{
				const activityRef = doc(db, "Weeds", key);
				deleteDoc(activityRef);
				return false;
			}
			return true;
		});
		setWeeds(weeds);
	}
}